<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>CTA text:</div>
      </div>
      <div class="row">
        <div class="col-12">
          <p-select
            #ctaTextDropdown
            [options]="ctaTexts"
            [(ngModel)]="selectedCtaText"
            [disabled]="disabled"
            [showClear]="true"
            [placeholder]="ctaPlaceholder"
            [style]="{ width: '100%', zIndex: '3' }"
            [ngModelOptions]="{ standalone: true }"
            name="ctaTextDropdown"
            scrollHeight="25rem"
            (onChange)="onChange($event.value ?? '', 'Text')"
          >
            <ng-template let-ctaText pTemplate="item">
              <div class="cta-option">{{ ctaText }}</div>
            </ng-template>
          </p-select>
        </div>
      </div>
    </div>
  </div>
</main>
